import { Fragment } from "react";

import pdfIcon from "./pdf-icon.svg";

const FileView = (props) => {
  const { fileURL, onRemove } = props;

  const type = fileURL.split(".").pop();

  const imageTypes = {
    pdf: () => (
      <div className="pdf-view relative">
        <div
          className="pointer pdf-image-container"
          onClick={() => window.open(fileURL, "_blank")}
        >
          <img className="pdf-image" src={pdfIcon} alt="pdf" loading="lazy" />
        </div>
        <p className="mt-2 pdf-title">PDF Document</p>

        {onRemove && (
          <img
            className="remove-file-icon"
            src="./assets/icons/close.svg"
            alt="close"
            onClick={onRemove}
          />
        )}
      </div>
    ),
  };

  return (
    <Fragment>
      {imageTypes[type] ? (
        imageTypes[type]()
      ) : !onRemove ? (
        <div className="preview-image-container">
          <img src={`${fileURL}?size=lg`} alt={fileURL} className="img-size" />
        </div>
      ) : (
        <div
          className="relative remove-image-container"
          key={new Date().getTime()}
        >
          <img
            src={`${fileURL}?size=lg`}
            alt="img"
            className="img-size"
            decoding="async"
          />
          <img
            className="remove-file-icon"
            src="./assets/icons/close.svg"
            alt="close"
            onClick={onRemove}
          />
        </div>
      )}
    </Fragment>
  );
};

export default FileView;
